import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ORDER_PRODUCT_TYPES } from '../Utils/constantData';
import { notify } from '../Utils/toastify';
import endPoints from '../api/endpoint';
import { OrderSortKeys, OrderState } from '../types';
import {
  deleteApiCall,
  getApiCall,
  patchApiCall,
  postApiCall,
  putApiCall,
} from '../api/methods';
import { logout } from './authSlice';
import { logout as chatLogout } from '../Pages/Chats/chat.slice';
import store, { RootState } from './store';
import { getPreviewShiftDetails, setCommonDataLoader } from './commonSlice';
import { setProductLoader } from './products';
import { capitalizeFirstLetter } from '../Utils/helperFns';
import { auth } from '../Utils/firebaseConfig';
import { signOut } from 'firebase/auth';

import { setSchdulesTypes } from './riskCenterSlice';
import dayjs from 'dayjs';

const initialState: OrderState = {
  quantity: 1,
  businessAddress: null,
  shifts: 0,
  shiftsError: '',
  departmentList: [],
  orders: [],
  orderDetailsLoader: false,
  loader: false,
  error: false,
  page: 1,
  filter: null,
  searchKeywords: '',
  productOrderList: null,
  vendorlist: [],
  rentProdctsList: [],
  worksheetDetails: null,
  orderDetails: null,
  setNameList: [],
  episodeNameList: [],
  locationList: [],
  editedItem: null,
  cancleOrderModalData: null,
  addToOrderType: null,
  deliveryAddressModalData: null,
  listLoader: {
    setNames: false,
    locations: false,
    updateAddress: false,
  },
  rentalModalDetails: {
    state: false,
    itemDetails: null,
    cartId: '',
    rentPriceValue: '',
    rentalDetails: null,
  },
  quotationShifts: null,
  qoutationCartDetails: null,
  sortKey: OrderSortKeys.updatedAt,
  sortMode: -1,
  shiftPreviewData: {},
  invoiceDetails: null,
  invoiceDetailsLoader: false,
  invoicePriceBreakup: null,
  priceBreakupLoader: false,
  invoiceItemPriceBreakup: null,
  paymentHistory: null,
  paymentHistoryLoader: false,
  invoiceNotes: null,
  invoiceNotesLoader: false,
  invoiceReceipt: null,
  invoiceReceiptLoader: false,
  worksheetNotes: null,
  invoiceWorksheetData: null,
  expandedWorksheet: null,
  shiftPreviewAppendEpoch: 0,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrderList: (state, action) => {
      const { payload }: any = action;
      state.orders = payload;
    },
    setVendorList: (state, action) => {
      const { payload }: any = action;
      state.vendorlist = payload;
    },
    setOrderLoader: (state, action) => {
      const { payload }: any = action;
      state.orderDetailsLoader = payload;
    },
    setInvoiceLoader: (state, action) => {
      const { payload }: any = action;
      state.invoiceDetailsLoader = payload;
    },
    setPriceBreakupLoader: (state, action) => {
      const { payload }: any = action;
      state.priceBreakupLoader = payload;
    },
    setOrderError: (state, action) => {
      const { payload }: any = action;
      state.error = payload;
    },
    setPage: (state, action) => {
      const { payload }: any = action;
      state.error = payload;
    },
    setLoaderStatus: (state, action) => {
      const { payload } = action;
      state.loader = payload;
    },
    setSearchKeywords: (state, action) => {
      const { payload }: any = action;
      state.searchKeywords = payload;
    },
    setFilters: (state, action) => {
      const { payload }: any = action;
      state.filter = payload;
    },
    setDepartmentlist: (state, action) => {
      state.departmentList = action.payload;
    },
    setOrderProductList: (state, action) => {
      const { payload }: any = action;
      state.productOrderList = payload;
    },
    setRentOrderProductList: (state, action) => {
      const { payload }: any = action;
      state.rentProdctsList = payload;
    },
    setWorkSheetDetails: (state, action) => {
      const { payload }: any = action;
      state.worksheetDetails = payload;
    },
    setOrderDetails: (state, action) => {
      const { payload }: any = action;
      state.orderDetails = payload;
    },
    setNameList: (state, action) => {
      const { payload }: any = action;
      state.setNameList = payload;
    },
    setEpisodeNameList: (state, action) => {
      const { payload }: any = action;
      state.episodeNameList = payload;
    },
    setLocationList: (state, action) => {
      const { payload }: any = action;
      state.locationList = payload;
    },
    // updateAddress: (state, action) => {
    //   const { payload }: any = action
    //   state.addressUpdate = payload
    // },
    setEditedItem: (state, action) => {
      const { payload }: any = action;
      state.editedItem = payload;
    },
    setCancelModalData: (
      state,
      action: PayloadAction<{
        isOrderCancle: boolean;
        orderDetails?: any;
      } | null>,
    ) => {
      const { payload } = action;
      state.cancleOrderModalData = payload;
    },
    setDeliveryAddressModalStatus: (state, action: PayloadAction<any>) => {
      const { payload } = action;
      state.deliveryAddressModalData = payload;
    },
    updateAddToOrderType: (state, action) => {
      const { payload }: any = action;
      state.addToOrderType = payload;
    },
    updateListLoader: (state, action) => {
      const {
        payload: { type, value },
      }: any = action;
      state.listLoader[type] = value;
    },
    updateRentalModalData: (state, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rentalModalDetails = payload;
    },
    setQuotationShifts: (state, action) => {
      const { payload }: any = action;
      state.quotationShifts = payload;
    },
    updateQoutationDetails: (state, action) => {
      const { payload }: any = action;
      state.qoutationCartDetails = payload;
    },
    updateSortKey: (state, action) => {
      const { payload }: any = action;
      state.sortKey = payload;
    },
    updateSortMode: (state, action) => {
      const { payload }: any = action;
      state.sortMode = payload;
    },
    increment: state => {
      state.quantity = state.quantity + 1;
    },
    setShiftsError: (state, action) => {
      const { payload }: any = action;
      state.shifts = 0;
      state.shiftsError = payload;
    },
    decrement: state => {
      if (state.quantity > 1) state.quantity = state.quantity - 1;
    },
    setQuantity: (state, action) => {
      if (!action.payload) {
        state.quantity = 1;
      } else state.quantity = action.payload;
    },
    setShifts: (state, action) => {
      state.shiftsError = '';
      state.shifts = action.payload;
    },
    setBusniessAddress: (state, action) => {
      const { payload } = action;
      state.businessAddress = payload;
    },
    setShiftPreviewData: (state, action) => {
      const { payload }: any = action;

      state.shiftPreviewData = payload;
    },
    bumpShiftPreviewAppendEpoch: state => {
      state.shiftPreviewAppendEpoch = (state.shiftPreviewAppendEpoch ?? 0) + 1;
    },
    setInvoiceDetails: (state, action) => {
      const { payload }: any = action;
      state.invoiceDetails = payload;
    },
    setInvoicePriceBreakup: (state, action) => {
      const { payload }: any = action;
      state.invoicePriceBreakup = payload;
    },
    setInvoiceItemPriceBreakup: (state, action) => {
      const { payload }: any = action;
      state.invoiceItemPriceBreakup = payload;
    },
    setPaymentHistory: (state, action) => {
      const { payload }: any = action;
      state.paymentHistory = payload;
    },
    setPaymentHistoryLoader: (state, action) => {
      const { payload }: any = action;
      state.paymentHistoryLoader = payload;
    },
    setInvoiceNotes: (state, action) => {
      const { payload }: any = action;
      state.invoiceNotes = payload;
    },
    setInvoiceNotesLoader: (state, action) => {
      const { payload }: any = action;
      state.invoiceNotesLoader = payload;
    },
    setInvoiceReceipt: (state, action) => {
      const { payload }: any = action;
      state.invoiceReceipt = payload;
    },
    setInvoiceReceiptLoader: (state, action) => {
      const { payload }: any = action;
      state.invoiceReceiptLoader = payload;
    },
    setWorksheetData: (state, action) => {
      const { payload }: any = action;
      state.invoiceWorksheetData = payload;
    },
    setExpandedWorksheetData: (state, action) => {
      const { payload }: any = action;
      state.expandedWorksheet = payload;
    },
    setWorksheetNotes: (state, action) => {
      const { payload }: any = action;
      state.worksheetNotes = payload;
    },
  },
});

export const {
  setOrderList,
  setOrderLoader,
  setOrderError,
  setShifts,
  increment,
  decrement,
  setQuantity,
  setPage,
  setSearchKeywords,
  setFilters,
  setOrderProductList,
  setRentOrderProductList,
  setWorkSheetDetails,
  setOrderDetails,
  setNameList,
  setEpisodeNameList,
  setLocationList,
  setShiftsError,
  // updatePersonalAddress,
  // updateAddress,
  setEditedItem: setEditedItemStore,
  setCancelModalData,
  setDeliveryAddressModalStatus,
  updateAddToOrderType,
  updateListLoader,
  updateRentalModalData,
  setQuotationShifts,
  updateQoutationDetails,
  setVendorList,
  updateSortKey,
  updateSortMode,
  setBusniessAddress,
  setLoaderStatus,
  setDepartmentlist,
  setShiftPreviewData,
  bumpShiftPreviewAppendEpoch,
  setInvoiceDetails,
  setInvoiceLoader,
  setInvoicePriceBreakup,
  setPriceBreakupLoader,
  setInvoiceItemPriceBreakup,
  setPaymentHistory,
  setPaymentHistoryLoader,
  setInvoiceNotes,
  setInvoiceNotesLoader,
  setInvoiceReceipt,
  setInvoiceReceiptLoader,
  setExpandedWorksheetData,
  setWorksheetData,
  setWorksheetNotes,
} = orderSlice.actions;

export default orderSlice.reducer;

export const handleError = async (e: any) => {
  const { dispatch } = store;

  if (e.data && e.data.message) {
    notify(e.data.message, 'error');
  }
  if (e.data && e.data.statusCode === 401) {
    await signOut(auth);
    localStorage.removeItem('phoneNumber'); // Remove stored phone number
    localStorage.removeItem('confirmationResult'); // Remove stored OTP session
    localStorage.removeItem('accessToken'); // Remove authentication token
    window.recaptchaVerifier = null; // Reset reCAPTCHA
    dispatch(logout());
    dispatch(chatLogout());
  }
};

export const getAndSetOrderList = (
  query = '?pageNo=1&limit=10',
  branchId: string | null = null,
): any => {
  const { dispatch, getState } = store;
  const searchKeyword = getState().order.filter?.searchKey;
  const searchQuery = searchKeyword
    ? `&searchKey=${encodeURIComponent(searchKeyword)}`
    : '';
  const filters = getState().order.filter;
  const {
    order: { sortKey, sortMode },
  }: RootState = getState();
  let filterQuery = '';
  if (filters) {
    if (filters.fromDate) {
      filterQuery += `&fromDate=${filters.fromDate}&toDate=${filters.toDate}`;
    }
    if (filters.status) {
      // filters.status.forEach((status: any) => {
      filterQuery += `&status=${filters.status}`;
      // })
    }
    if (filters.vendorId) {
      // filters.status.forEach((status: any) => {
      filterQuery += `&vendorId=${filters.vendorId}`;
      // })
    }
  }
  if (branchId) {
    filterQuery += `&branchId=${branchId}`;
  }
  filterQuery += `&sortBy=${sortKey}&sortOrder=${sortMode}`;

  const params = `${query}${searchQuery}${filterQuery}`;
  const apiEndpoint = endPoints.order.list;
  dispatch(setOrderLoader(true));
  getApiCall(
    `${apiEndpoint}${params}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setOrderList(data.data));
      }
      dispatch(setOrderLoader(false));
    },
    (e: any) => {
      if (e.data && e.data.message) {
        notify(e.data.message, 'error');
      }
      if (e.data && e.data.statusCode === 401) {
        // await signOut(auth)
        localStorage.removeItem('phoneNumber'); // Remove stored phone number
        localStorage.removeItem('confirmationResult'); // Remove stored OTP session
        localStorage.removeItem('accessToken'); // Remove authentication token
        window.recaptchaVerifier = null; // Reset reCAPTCHA
        dispatch(logout());
        dispatch(chatLogout());
      }
      dispatch(setOrderLoader(false));
    },
    branchId ? { ['branch_id']: branchId } : {},
  );
};
export const getVendorList = (args?: any, cb?: any) => {
  console.log('newPagenewPage', args);
  return (dispatch: any, getState: any) => {
    getApiCall(
      `${endPoints.commissionManagement.vendorList}?limit=${100}&pageNo=${
        args?.pageNo || 1
      }${args?.search ? `&searchKey=${args?.search}` : ''}`,

      (s: any) => {
        const {
          data: { statusCode },
          data,
        } = s;
        if (statusCode && statusCode === 200) {
          // console.log('DDDDDD=>', data.data)
          dispatch(
            setVendorList(
              data?.data?.data?.map((vendor: any) => ({
                ...vendor,
                businessName: capitalizeFirstLetter(vendor.businessName),
              })) || [],
            ),
          );
        }
        cb && cb();
      },
      (e: any) => {
        if (e?.data && e?.data.message) {
          notify(e?.data.message, 'error');
        }
      },
    );
  };
};

export const getOrderProductsList = (
  vendorId: string,
  productType: string | null = null,
  pagination: string | null = null,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  let query = `?vendorOrderId=${vendorId}`;
  if (productType) {
    query += `&shoppingMode=${productType}`;
  }
  if (pagination) {
    query += `&${pagination}`;
  }

  getApiCall(
    `${endPoints.order.productItems}${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (productType === ORDER_PRODUCT_TYPES.buy) {
          dispatch(setOrderProductList(data.data));
        } else if (productType === ORDER_PRODUCT_TYPES.rent) {
          dispatch(setRentOrderProductList(data.data));
        } else {
          dispatch(setOrderProductList(data.data));
        }
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getAndOrderDetails = (orderId: string) => {
  const { dispatch } = store;
  dispatch(setOrderLoader(true));
  getApiCall(
    `${endPoints.order.list}/${orderId}`,
    (s: any) => {
      const { data } = s;
      if (data.data && data.data[0]) {
        dispatch(setOrderDetails(data.data[0]));
      }
      dispatch(setOrderLoader(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setOrderLoader(false));
    },
  );
};

export const getSetNameList = (productionId: string, callBack: Function) => {
  const { dispatch } = store;
  dispatch(updateListLoader({ type: 'setNames', value: true }));
  getApiCall(
    `${endPoints.order.list}/production-set-location?type=SET&id=${productionId}`,
    (s: any) => {
      const { data } = s?.data;
      console.log(data, 'data set name');
      if (data) {
        if (data) {
          dispatch(setNameList(data));
        }
        if (data?.episodeList && data?.episodeList?.length) {
          dispatch(setEpisodeNameList(data?.episodeList));
        }
        callBack();
      }
      dispatch(updateListLoader({ type: 'setNames', value: false }));
    },

    (e: any) => {
      handleError(e);
      dispatch(updateListLoader({ type: 'setNames', value: false }));
    },
  );
};

export const getSetLocationList = (setId: string) => {
  const { dispatch } = store;
  dispatch(updateListLoader({ type: 'locations', value: true }));

  getApiCall(
    `${endPoints.order.list}/production-set-location?type=LOCATION&id=${setId}`,
    (s: any) => {
      const {
        data: { data },
      } = s;

      if (data) {
        dispatch(setLocationList(data));
      }
      dispatch(updateListLoader({ type: 'locations', value: false }));
    },
    (e: any) => {
      handleError(e);
      dispatch(updateListLoader({ type: 'locations', value: false }));
    },
  );
};

export const cancleOrder = (
  data: any,
  // id: string,
  cb: (data: boolean) => void,
) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem },
  }: RootState = getState();
  dispatch(setCommonDataLoader(true));
  const cloneData = { ...data };
  console.log(cancleOrderModalData?.isOrderCancle, 'what');
  if (!cancleOrderModalData?.isOrderCancle && editedItem) {
    // cloneData['productId'] = editedItem.product.productId
    cloneData['itemId'] = editedItem.product._id;
    // cloneData['vendorOrderId'] = editedItem.product.vendorOrderId
    console.log(editedItem?._id, 'Edited ID');
  }

  if (cloneData['cancelNote'].trim() == '') {
    delete cloneData['cancelNote'];
  }
  // if(cancleOrderModalData?.orderDetails?._id !== cancleOrderModalData?.orderDetails?.vendorOrderId){
  // cloneData['itemId'] = cancleOrderModalData?.orderDetails?._id
  // }
  console.log(cancleOrderModalData?.orderDetails, 'Cancel Modal Order Data');
  patchApiCall(
    endPoints.order.cancleOrder(
      cancleOrderModalData?.orderDetails?.vendorOrderId,
    ),
    cloneData,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      if (data && statusCode && statusCode === 200) {
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(true));
    },
  );
};
export const cancleSingleOrder = (
  data: any,
  id: string,
  cb: (data: boolean) => void,
) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem },
  }: RootState = getState();
  dispatch(setCommonDataLoader(true));
  const cloneData = { ...data };
  if (!cancleOrderModalData?.isOrderCancle && editedItem) {
    // cloneData['productId'] = editedItem.product.productId
    // cloneData['orderId'] = editedItem.product._id
    // cloneData['vendorOrderId'] = editedItem.product.vendorOrderId
  } else if (cancleOrderModalData) {
    const { orderDetails } = cancleOrderModalData;
    // cloneData['orderId'] = orderDetails.data
    //   ? orderDetails.data.orderId
    //   : orderDetails.orderId
    // cloneData['vendorOrderId'] = orderDetails.vendorOrderId
  }
  if (cloneData['cancelNote'].trim() == '') {
    delete cloneData['cancelNote'];
  }
  cloneData['itemId'] = cancleOrderModalData?.orderDetails?._id;
  patchApiCall(
    endPoints.order.cancleOrder(id),
    cloneData,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      if (data && statusCode && statusCode === 200) {
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(true));
    },
  );
};

export const updateQuantity = (
  data: any,
  vendorOrderId: any,
  orderId: any,
  cb: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  patchApiCall(
    `${endPoints.order.updateQuantity + vendorOrderId}/items/${orderId}/qty`,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 200) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateRentQuantity = (data: any, cb: any) => {
  const { qty, id } = data;
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  putApiCall(
    endPoints.order.updateRentQuantity(id),
    { qty },
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (id && statusCode && statusCode === 202) {
        notify('Qty Updated Successfully.', 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const rentApproveReject = (data: any, cb: any) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem, productOrderList },
  }: RootState = getState();
  dispatch(setCommonDataLoader(true));
  const { id, status, reason, note, vendorOrderId } = data;

  patchApiCall(
    `${
      endPoints.order.rentApproveReject + vendorOrderId
    }/items/${id}/accept-reject`,
    { status, ...(reason && { reason }), ...(note && { note }) },
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 200) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateStatus = (data: any, id: any, orderId: any, cb: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  const { status } = data;

  patchApiCall(
    `${endPoints.order.updateStatus}/${id}/items/${orderId}/status`,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 200) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateAddressCall = (
  data: any,
  vendorOrderId: any,
  orderId: any,
  cb: any,
) => {
  const { dispatch } = store;
  dispatch(updateListLoader({ type: 'updateAddress', value: true }));

  patchApiCall(
    `${endPoints.order.updateAddress + vendorOrderId}/items/${orderId}/address`,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (data && statusCode && statusCode === 200) {
        notify('Address update successfully', 'success');
        cb(true);
      }
      dispatch(updateListLoader({ type: 'updateAddress', value: false }));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(updateListLoader({ type: 'updateAddress', value: false }));
    },
  );
};

export const addProductsToOrder = (cb: (flag: boolean) => void) => {
  const { dispatch, getState } = store;
  const {
    product: { selectedIds },
    order: { orderDetails },
  }: RootState = getState();
  dispatch(setCommonDataLoader(true));
  postApiCall(
    endPoints.order.addProducts(orderDetails._id),
    {
      shoppingMode: 'BUY',
      products: selectedIds.map(p => {
        return { productId: p, isRushApply: false };
      }),
    },
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      if (statusCode && statusCode === 200) {
        notify('Item added successfully into order', 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const addPersonalAddress = (
  data: any,
  vendorOrderId: any,
  orderId: any,
  cb: any,
) => {
  const { dispatch, getState } = store;
  // dispatch(setCommonDataLoader(true))
  patchApiCall(
    `${endPoints.order.updateAddress + vendorOrderId}/items/${orderId}/address`,
    data,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      if (statusCode && statusCode === 200) {
        notify('Address added successfully', 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
    },
  );
};

export const getCartId = (payload: any, cb: any) => {
  const { dispatch, getState } = store;

  dispatch(setCommonDataLoader(true));
  postApiCall(
    `${endPoints.order.createCart}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;
      if (statusCode && statusCode === 200 && data && data.cartId) {
        cb(data.cartId);
      }
      cb(false);

      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateCartRentalDetails = (
  cartId: string,
  payload: any,
  cb: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  putApiCall(
    `${endPoints.order.cartRentalDetailsUpdate(cartId)}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      if (statusCode && statusCode === 202) {
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const addToOrderRentProducts = (payload: any, cb: any) => {
  const { dispatch, getState } = store;
  dispatch(setCommonDataLoader(true));
  postApiCall(
    `${endPoints.order.addItemServicesToOrder}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;
      if (statusCode && statusCode === 200) {
        // notify('Item added successfully into order', 'success')
        notify('Items added to order.', 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const createOrderQoute = (payload: any, cb: any) => {
  const { dispatch, getState } = store;
  dispatch(setCommonDataLoader(true));
  postApiCall(
    `${endPoints.order.quotationCart}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;
      if (statusCode && statusCode === 200) {
        // notify('Item added successfully into order', 'success')
        notify('Order is created for qoutation.', 'success');
        cb(true, data);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateCart = (payload: any, cb: any) => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));
  putApiCall(
    `${endPoints.order.updateCartOrDelete}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;
      if (statusCode && statusCode === 200) {
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getWorksheetDetails = (id: string, query: string) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  getApiCall(
    `${endPoints.order.viewWorksheet(id)}${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setWorkSheetDetails(data.data));
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const extendService = (data: any, cb: any) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem, productOrderList },
  }: RootState = getState();
  // dispatch(setCommonDataLoader(true))
  const { id, startDate, endDate } = data;

  putApiCall(
    endPoints.order.extend_service(id),
    { startDate, endDate },
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 202) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateShift = (data: any, cb: any) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem, productOrderList },
  }: RootState = getState();
  // dispatch(setCommonDataLoader(true))
  const { id, startDate, endDate } = data;

  putApiCall(
    endPoints.order.updateShift(id),
    { endDate },
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 202) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const updateShiftAcceptReject = (data: any, cb: any) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem, productOrderList },
  }: RootState = getState();
  // dispatch(setCommonDataLoader(true))
  const { id, status } = data;

  putApiCall(
    endPoints.order.updateStatusShift(id),
    { status },
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (data && statusCode && statusCode === 202) {
        notify(message, 'success');
        cb(true);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      cb(false);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getQuotationWorkSheetShifts = (cartId: string, query: string) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  getApiCall(
    `${endPoints.order.quotationShifts}?cartId=${cartId}${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setQuotationShifts(data.data));
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getQuotationCartDetails = () => {
  const { dispatch, getState } = store;
  const {
    chat: { selectedQuote },
  }: RootState = getState();
  if (selectedQuote?._id) {
    dispatch(setProductLoader(true));
    getApiCall(
      `${endPoints.order.quotationCartDetails}${selectedQuote?._id}?userId=${selectedQuote.createdBy}`,
      (s: any) => {
        const { data } = s;
        if (data.data) {
          dispatch(updateQoutationDetails(data.data));
        }
        dispatch(setProductLoader(false));
      },
      (e: any) => {
        handleError(e);
        dispatch(setProductLoader(false));
      },
    );
  }
};

export const deleteCart = (query: string, loader = false) => {
  const { dispatch } = store;

  loader && dispatch(setCommonDataLoader(true));
  deleteApiCall(
    `${endPoints.order.updateCartOrDelete}?${query}`,
    {},
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      loader && dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      // handleError(e)
      loader && dispatch(setCommonDataLoader(false));
    },
  );
};

export const findLocationByText = async (location: string, thunkApi: any) => {
  if (!location.length) {
    return [];
  }
  try {
    const apiResult = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=AIzaSyCu3pQ2rxalRAWIONNcxoYST8Cy7NJrveA`,
    ).then(response => response.json());

    if (apiResult) {
      const { status, results } = apiResult;
      if (results && results.length) {
        return results;
      }
      return [];
    }
    return [];
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
};
export const clearFields = () => {
  const { dispatch } = store;
  dispatch(setDepartmentlist({}));
  dispatch(setSchdulesTypes({}));
};

// getShift COverage
export const getShiftQuotation = (payload: any) => {
  const { dispatch } = store;

  postApiCall(
    endPoints.order.getShifts,
    payload,
    (response: any) => {
      const { data } = response;
      if (data) {
        dispatch(setShifts(data.data.lastShiftDuration)); // action to update your redux store with cart details
      }
    },
    async (e: any) => {
      handleError(e);
    },
  );
};
export const addToCart = (payload: any, cb?: any, errorcb?: any) => {
  console.log('dataToSend', payload);
  // dispatch(setCommonDataLoader(true))
  postApiCall(
    `${endPoints.order.addCart}`,
    payload,
    (s: any) => {
      const {
        data: { message, data },
      } = s;

      if (message === 'Success') {
        // notify('Added to cart', 'success');
        if (cb) cb(data);
      }
    },
    async (e: any) => {
      errorcb();
      handleError(e);
    },
  );
};
export const getBusinessAddress = (id?: string) => {
  const { dispatch } = store;
  dispatch(setLoaderStatus(true));
  let apiendpoint = endPoints.riskCenter.businessAddress;

  if (id) {
    apiendpoint = `${apiendpoint}?productionId=${id}`;
  }
  // dispatch(setLoaderStatus(true))
  // Make the API call

  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        console.log('Addressss=>>>>>', data);
        dispatch(setBusniessAddress(data?.data));
        dispatch(setLoaderStatus(false));
      }
    },
    async (e: any) => {
      handleError(e);
    },
  );
};
export const getDepartmentList = (entityId?: any, cb?: any) => {
  const { dispatch } = store;
  const queryParams = [];

  if (entityId) queryParams.push(`productionId=${entityId}`);

  const apiendpoint = `${endPoints.order.getDepartmentList}${
    queryParams.length ? `?${queryParams.join('&')}` : ''
  }`;
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        const currentData = data.data.depts;
        dispatch(setDepartmentlist(currentData));
        cb(currentData);
      }
    },

    async (e: any) => {
      handleError(e);
    },
  );
};

/** Normalize paginated worksheets payload: API may nest the cart array as `data.data` or top-level `data` array. */
function extractShiftPreviewCartRows(apiInner: any): any[] {
  if (!apiInner) return [];
  const bucket = apiInner.data;
  if (Array.isArray(bucket?.data)) return bucket.data;
  if (Array.isArray(bucket)) return bucket;
  return [];
}

function mergeShiftPreviewTotals(
  apiInner: any,
  currentState: any,
): number | undefined {
  const bucket = apiInner?.data;
  const fromPage =
    (typeof bucket?.total === 'number' ? bucket.total : undefined) ??
    (typeof apiInner?.total === 'number' ? apiInner.total : undefined);
  return fromPage ?? currentState?.data?.total;
}

export const getShiftPreviewData = (query: string, append = false) => {
  const { dispatch, getState } = store;
  const { previewShiftDetails } = getState().common;
  if (!append) {
    dispatch(setLoaderStatus(true));
  }

  getApiCall(
    `${endPoints.riskCenter.shiftDetail}?${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // console.log('data', data);
        // getPreviewShiftDetails({
        //   ...previewShiftDetails,
        //   shiftTimes: {
        //     ...previewShiftDetails?.shiftTimes,
        //     fromDate: dayjs(data?.data?.cartDetails?.startTime).valueOf(),
        //     toDate: dayjs(data?.data?.cartDetails?.endTime).valueOf(),
        //   },
        // });
        if (append) {
          // For pagination - append new data to existing data
          const currentState = getState().order.shiftPreviewData;
          const existingData = currentState?.data?.data || [];
          const newData = extractShiftPreviewCartRows(data.data);
          const allShifts = [...existingData, ...newData];

          const updatedData = {
            ...currentState,
            data: {
              ...currentState.data,
              data: allShifts,
              total: mergeShiftPreviewTotals(data.data, currentState),
            },
          };

          dispatch(setShiftPreviewData(updatedData));
        } else {
          // For initial load - replace all data

          dispatch(setShiftPreviewData(data.data));
        }
      }
      dispatch(setLoaderStatus(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setLoaderStatus(false));
      if (append) {
        dispatch(bumpShiftPreviewAppendEpoch());
      }
    },
  );
};

export const getShiftPreviewDataStart = (query: string, append = false) => {
  const { dispatch, getState } = store;
  const { previewShiftDetails } = getState().common;
  if (!append) {
    dispatch(setLoaderStatus(true));
  }

  getApiCall(
    `${endPoints.riskCenter.shiftDetail}?${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // console.log('data', data);
        getPreviewShiftDetails({
          ...previewShiftDetails,
          shiftTimes: {
            ...previewShiftDetails?.shiftTimes,
            fromDate: dayjs(data?.data?.cartDetails?.startTime).valueOf(),
            toDate: dayjs(data?.data?.cartDetails?.endTime).valueOf(),
          },
        });
        if (append) {
          const currentState = getState().order.shiftPreviewData;
          const existingData = currentState?.data?.data || [];
          const newData = extractShiftPreviewCartRows(data.data);
          const allShifts = [...existingData, ...newData];

          const updatedData = {
            ...currentState,
            data: {
              ...currentState.data,
              data: allShifts,
              total: mergeShiftPreviewTotals(data.data, currentState),
            },
          };

          dispatch(setShiftPreviewData(updatedData));
        } else {
          // For initial load - replace all data
          dispatch(setShiftPreviewData(data.data));
        }
      }
      dispatch(setLoaderStatus(false));
    },
    (e: any) => {
      handleError(e);
      dispatch(setLoaderStatus(false));
      if (append) {
        dispatch(bumpShiftPreviewAppendEpoch());
      }
    },
  );
};
export const updateShiftPreview = (
  data: any,
  type: string,
  cb: any,
  errorcb?: any,
) => {
  const { dispatch, getState } = store;
  const {
    order: { cancleOrderModalData, editedItem, productOrderList },
  }: RootState = getState();

  putApiCall(
    type === 'fromOrder'
      ? endPoints.order.editShiftInOrder
      : endPoints.order.editShiftInPreview,
    data,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Shift updated successfully', 'success');
        cb(data);
      }
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      handleError(e);
      // cb(false);
      errorcb && errorcb();
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getShiftNotes = (query: string) => {
  const { dispatch } = store;
  getApiCall(
    `${endPoints.order.shiftNotes}?${query}`,
    (s: any) => {
      const { data } = s;
      console.log('data', data);
    },
    (e: any) => {
      handleError(e);
    },
  );
};

export const fetchInvoiceDetails = (
  invoiceId: string,
  dispatch: any,
  cb?: any,
) => {
  dispatch(setInvoiceLoader(true));

  getApiCall(
    `${endPoints.order.invoices}/${invoiceId}`,
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceDetails(data));
      dispatch(setInvoiceLoader(false));
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
      dispatch(setInvoiceLoader(false));
    },
  );
};

export const getInvoiceItemPriceBreakup = (
  invoiceId: string,
  itemId: string,
  dispatch?: any,
  startDate?: string,
  endDate?: string,
  setId?: string,
  locationId?: string,
  cb?: any,
) => {
  dispatch(setPriceBreakupLoader(true));

  const queryParams = new URLSearchParams();
  if (startDate) {
    // Convert date string to timestamp in milliseconds
    const timestamp = new Date(startDate).getTime();
    queryParams.append('startDate', timestamp.toString());
  }
  if (endDate) {
    // Convert date string to timestamp in milliseconds
    const timestamp = new Date(endDate).getTime();
    queryParams.append('endDate', timestamp.toString());
  }
  if (setId) {
    queryParams.append('setId', setId);
  }
  if (locationId) {
    queryParams.append('locationId', locationId);
  }
  const queryString = queryParams.toString();

  getApiCall(
    `${endPoints.order.invoices}/${invoiceId}/items/${itemId}/price-breakup${
      queryString ? `?${queryString}` : ''
    }`,
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceItemPriceBreakup(data));
      dispatch(setPriceBreakupLoader(false));
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
      dispatch(setPriceBreakupLoader(false));
    },
  );
};
export const getInvoicePriceBreakup = (invoiceId: string, dispatch?: any) => {
  dispatch(setPriceBreakupLoader(true));

  getApiCall(
    `${endPoints.order.invoices}/${invoiceId}/price-breakup`,
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoicePriceBreakup(data));
      dispatch(setPriceBreakupLoader(false));
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
      dispatch(setInvoicePriceBreakup(null));
      dispatch(setPriceBreakupLoader(false));
    },
  );
};

export const getInvoiceNotes = (
  invoiceId: string,
  dispatch?: any,
  page?: number,
  limit?: number,
) => {
  dispatch(setInvoiceNotesLoader(true));

  getApiCall(
    `${endPoints.order.invoices}/${invoiceId}/notes${
      page ? `?page=${page}` : ''
    }${limit ? `&limit=${limit}` : ''}`,
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceNotes(data));
      dispatch(setInvoiceNotesLoader(false));
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
      dispatch(setInvoiceNotesLoader(false));
    },
  );
};

export const getInvoiceReceipt = (invoiceId: string) => {
  const { dispatch } = store;
  dispatch(setInvoiceReceiptLoader(true));
  getApiCall(
    `${endPoints.order.invoices}/${invoiceId}/receipt`,
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceReceipt(data));
      dispatch(setInvoiceReceiptLoader(false));
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
      dispatch(setInvoiceReceiptLoader(false));
    },
  );
};

export const approveInvoice = (invoiceId: string, onSuccess?: () => void) => {
  const { dispatch } = store;
  dispatch(setInvoiceReceiptLoader(true));
  putApiCall(
    `${endPoints.order.invoices}/${invoiceId}/approve`,
    {},
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceReceiptLoader(false));
      if (onSuccess) onSuccess();
    },
    (error: any) => {
      console.error('Error approving invoice:', error);
      dispatch(setInvoiceReceiptLoader(false));
    },
  );
};

export const rejectInvoice = (
  invoiceId: string,
  notes?: string,
  onSuccess?: () => void,
) => {
  const { dispatch } = store;
  dispatch(setInvoiceReceiptLoader(true));
  putApiCall(
    `${endPoints.order.invoices}/${invoiceId}/reject`,
    { notes: notes?.trim() || '' },
    (response: any) => {
      const data = response.data?.data;
      dispatch(setInvoiceReceiptLoader(false));
      if (onSuccess) onSuccess();
    },
    (error: any) => {
      console.error('Error rejecting invoice:', error);
      dispatch(setInvoiceReceiptLoader(false));
    },
  );
};

export const deleteOrCancelShift = (
  data: any,
  from: string,
  cb?: any,
  errorcb?: any,
) => {
  const { dispatch } = store;
  if (from == 'order') {
    deleteApiCall(
      `${endPoints.order.cancelShift}`,
      { data },
      (s: any) => {
        notify(s.data.message ?? 'Shift cancelled successfully', 'success');
        if (cb) cb();
      },
      (e: any) => {
        handleError(e);
      },
    );
  } else {
    deleteApiCall(
      `${endPoints.order.deleteShift}`,
      { data },
      (s: any) => {
        notify('Shift cancelled successfully', 'success');
        if (cb) cb();
      },
      (e: any) => {
        handleError(e);
        errorcb && errorcb();
      },
    );
  }
};

export const cancelItem = (data: any, cb?: any, errorCb?: any) => {
  putApiCall(
    `${endPoints.order.deleteItem}`,
    { orderItemIds: data },
    (s: any) => {
      notify(s.data.message ?? 'Item cancelled successfully', 'success');
      if (cb) cb();
    },
    (e: any) => {
      if (errorCb) errorCb();
      handleError(e);
    },
  );
};

export const downloadInvoiceReceipt = (
  invoiceId: string,
  setIsShowPdf?: any,
) => {
  getApiCall(
    `${endPoints.order.receipt}/${invoiceId}/download-receipt`,
    (response: any) => {
      if (response?.data?.statusCode === 200) {
        const data = response.data?.data;
        window.open(data?.receiptUrl, '_blank');
        if (setIsShowPdf) setIsShowPdf(true);
      } else if (response?.data?.statusCode === 204) {
        notify(response?.data?.message, 'warning');
      }
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
    },
  );
};
export const downloadInvoice = (invoiceId: string, setIsShowPdf?: any) => {
  getApiCall(
    `${endPoints.order.receipt}/${invoiceId}/download`,
    (response: any) => {
      if (response?.data?.statusCode === 200) {
        const data = response.data?.data;
        window.open(data?.invoiceUrl, '_blank');
        if (setIsShowPdf) setIsShowPdf(true);
      } else if (response?.data?.statusCode === 204) {
        notify(response?.data?.message, 'warning');
      }
    },
    (error: any) => {
      console.error('Error fetching order details:', error);
    },
  );
};
export const getWorksheetData = (id: any, cb?: () => void) => {
  const { dispatch } = store;
  dispatch(setOrderLoader(true));
  getApiCall(
    endPoints.order.getWorksheetDataInvoice + `/${id}/worksheet`,

    (response: any) => {
      dispatch(setWorksheetData(response?.data?.data));
      if (cb) cb();
      dispatch(setOrderLoader(false));
    },
    (error: any) => {
      notify(error?.data?.message || 'Something went wrong', 'error');
      dispatch(setOrderLoader(false));
    },
  );
};

export const getExpandedWorksheetData = (
  id: any,
  date: string,
  orderId: string,
  shiftType: string,
  cb?: () => void,
  errorcb?: () => void,
) => {
  const { dispatch } = store;
  const dat = new Date(date).getTime();
  getApiCall(
    endPoints.order.getWorksheetDataInvoice +
      `/${id}/worksheet/expand?orderId=${orderId}&date=${dat}&shiftType=${shiftType}`,

    (response: any) => {
      dispatch(setExpandedWorksheetData(response?.data?.data));
      if (cb) cb();
    },
    (error: any) => {
      errorcb && errorcb();
      notify(error?.data?.message || 'Something went wrong', 'error');
    },
  );
};
export const getWorksheetNotes = (
  id: any,
  query: string,
  cb?: () => void,
  errorcb?: () => void,
) => {
  const { dispatch } = store;

  getApiCall(
    endPoints.order.getWorksheetNotes + `/${id}/notes${query}`,
    (response: any) => {
      dispatch(setWorksheetNotes(response?.data));
      if (cb) cb();
    },
    (error: any) => {
      errorcb && errorcb();
    },
  );
};
